import http from './http'

export function getSales(page = 1, search = '', filters = {}) {
  const params = { page, ...filters }
  if (search) params.search = search
  return http.get('good_sales', { params }).then((res) => res.data)
}

export function getSalesSummary(filters = {}) {
  return http.get('sales/summary', { params: filters }).then((res) => res.data)
}

export function refundSale(id, reason) {
  return http.post(`sales/${id}/refund`, { reason }).then((res) => res.data)
}

export function exportSales(filters = {}) {
  return http.get('sales/export', {
    params: filters,
    responseType: 'blob',
  }).then((res) => res.data)
}

export function getSalesWeek() {
  return http.get('sales/week').then((res) => res.data)
}

export function getSalesMonth() {
  return http.get('sales/month').then((res) => res.data)
}

export function getSalesAnalytics() {
  return http.get('sales/analytics').then((res) => res.data)
}

export function getPayments() {
  // Тот же источник, что и админка «Типы оплаты» — только активные
  return http.get('payment_type', { params: { active_only: 1 } }).then((res) => {
    const list = Array.isArray(res.data) ? res.data : []
    return list
      .filter((type) => type.is_active !== false)
      .map((type) => ({
        id: type.id,
        label: type.label,
        value: type.value,
      }))
  })
}
